import localFont from 'next/font/local';
import { buildTypography } from '@dapp/multi-lib/sdaoui/Typography';

export const habenGrotesk = localFont({
  src: [
    {
      path: '../public/static/fonts/HabenGrotesk/woff2/HabenGrotesk-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/HabenGrotesk/woff2/HabenGrotesk-BoldItalic.woff2',
      weight: '700',
      style: 'italic',
    },
    {
      path: '../public/static/fonts/HabenGrotesk/woff2/HabenGrotesk-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
  variable: '--font-haben-grotesk',
});

export const gtPlanar = localFont({
  src: [
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Thin.woff2',
      weight: '100',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Light.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Regular.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Medium.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../public/static/fonts/GTPlanar/woff2/GT-Planar-Black.woff2',
      weight: '800',
      style: 'normal',
    },
  ],
  variable: '--font-gt-planar',
});

export const Body = buildTypography(`${gtPlanar.className}`);

export const Body1 = buildTypography(
  `${gtPlanar.className} body1 tracking-[0.4px] font-thin text-[1.25rem] leading-[1.875rem]`
);

export const Body2 = buildTypography(
  `${gtPlanar.className} body2 tracking-[0.4px] text-[0.75rem] lg:text-[0.875rem] leading-[1.125rem] lg:leading-[1.25rem]`
);

export const Body3 = buildTypography(
  `${gtPlanar.className} body3 tracking-[0.4px] text-[0.625rem] leading-[0.75rem] lg:text-[0.75rem] lg:leading-[1.125rem]`
);

export const Header3 = buildTypography(
  `${habenGrotesk.className} header3 font-bold text-[2rem] lg:text-[2.75rem]`
);

export const Header4 = buildTypography(
  `${habenGrotesk.className} header4 font-bold lg:text-[1.625rem]`
);

export const Header6 = buildTypography(
  `${habenGrotesk.className} header6 font-bold text-[1rem] font-semibold`
);

export const Title = buildTypography(`${habenGrotesk.className}`);

export const Title1 = buildTypography(
  `${habenGrotesk.className} title1 font-bold text-[1rem] lg:text-[1.25rem]`
);

export const Title2 = buildTypography(
  `${habenGrotesk.className} title2 font-bold md:text-[1.25rem] text-[0.75rem]`
);

export const Title3 = buildTypography(
  `${habenGrotesk.className} title3 font-bold text-[1rem] lg:text-[1.25rem] leading-[1.25rem] lg:leading-[1.5rem]`
);

export const Title4 = buildTypography(
  `${habenGrotesk.className} title4 font-bold text-[0.875rem] lg:text-[1rem] leading-[1.25rem]`
);

export const Title5 = buildTypography(
  `${habenGrotesk.className} title5 font-semibold lg:text-lg text-sm -tracking-[2%] text-white`
);

export const Tiny1 = buildTypography(
  `${gtPlanar.className} tiny1 text-[0.625rem] leading-[0.75rem]`
);

export const Tiny2 = buildTypography(
  `${gtPlanar.className} tiny1 text-[0.75rem] leading-[1rem]`
);

export const Heading2 = buildTypography(
  `${gtPlanar.className} text-lg text-white-600 header2 text-[1.875rem] font-semiBold`
);

export const Heading4 = buildTypography(
  `${gtPlanar.className} header4 text-[0.75rem] md:text-[1.25rem] font-normal`
);

export const Normal2 = buildTypography(
  `${habenGrotesk.className} text-[1.125rem] lending-[1.75rem] font-normal text-white-600`
);

export const Normal3 = buildTypography(
  `${gtPlanar.className} text-[1.5rem] font-bold text-white-600`
);

export const Normal4 = buildTypography(
  `${habenGrotesk.className} md:text-[1.625rem] text-[1.25rem] font-bold text-white`
);

export const Normal5 = buildTypography(
  `${habenGrotesk.className} md:text-[1.25rem] text-[1rem] font-bold`
);

export const Normal6 = buildTypography(
  `${habenGrotesk.className} lg:text-[1.625rem] text-[1.125rem] font-bold`
);

export const Button2 = buildTypography(
  `${habenGrotesk.className} button2 text-[0.875rem] lg:text-[1rem] font-semibold`
);

// 0.5rem (8px)
// 0.625rem (10px)
// 0.75rem (12px)
// 0.875rem (14px)
// 1rem (16px)
// 1.125rem (18px)
// 1.25rem (20px)
// 1.5rem (24px)
// 1.625rem (26px)
// 1.75rem (28px)
// 1.875rem (30px)
// 2rem (32px)
// 2.75rem (44px)
//1.625rem (26px)
